import PropTypes from "prop-types"
import React from "react"

import CountryFlag from "../CountryFlag"

import styles from "./FlagGroup.module.css"

function FlagGroup({ countries, size, className }) {
  return (
    <div className={[styles.root, className].join(" ")}>
      {countries.map(code => (
        <CountryFlag key={code} code={code} size={size} />
      ))}
      <div className="clearfix" />
    </div>
  )
}

FlagGroup.propTypes = {
  countries: PropTypes.array.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
}

FlagGroup.defaultProps = {
  size: 24,
  className: "",
}

export default FlagGroup
